import Vue from 'vue'
import App from './App'
import router from './router'
import 'fullpage.js/vendors/scrolloverflow'
import VueFullpage from 'vue-fullpage.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import $ from 'jquery'
// import './navigation/css/fullpage.min.css'
import animate from "animate.css"
import axios from 'axios'
import Bscroll from 'better-scroll'

import wcSwiper from 'wc-swiper'
import 'wc-swiper/style.css'
Vue.use(wcSwiper);

import "@/assets/text/text.css";


//分页
import './zpageNav/zpageNav.css'
import './zpageNav/zpageNav.js'

// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.min.js'


// 百度地图组件
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'ujIwV2Wj80R1hIN7dhpk4L7e1yGpWNjS'
})

// 视频组件
import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Videojs

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)



Vue.config.productionTip = false
Vue.use(VueFullpage)
Vue.use(ElementUI)
Vue.use(animate)

// if (window.location.hash && window.location.hash === '#/') {
//   window.location.replace(window.location.href.replace('#/', ''));
// }
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js